export default __webpack_public_path__ + "static/media/success-img.bc7aa4f0.png";